(() => {
  const MIN_SUBTOTAL_CENTS = 1000; // $10 minimum before Route can stay
  const ROUTE_MATCH = /route|shipping protection/i;

  async function getCart() {
    const r = await fetch('/cart.js', { credentials: 'same-origin' });
    return r.json();
  }

  async function changeLineByKey(key, quantity) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity })
    });
  }

  async function run() {
    try {
      // only run on cart-ish pages
      const isCartPage = window.location.pathname.includes('/cart');
      const hasCartDrawer = document.querySelector('cart-drawer, #CartDrawer, .cart-drawer');
      if (!isCartPage && !hasCartDrawer) return;

      const cart = await getCart();
      const requiresShipping = cart.items.some(i => i.requires_shipping);
      const meetsMin = cart.items_subtotal_price >= MIN_SUBTOTAL_CENTS;

      // cart qualifies: leave Route alone
      if (requiresShipping && meetsMin) return;

      // cart doesn't qualify: remove Route line item(s)
      for (const item of cart.items) {
        const title = item.product_title || item.title || '';
        if (ROUTE_MATCH.test(title)) {
          await changeLineByKey(item.key, 0);
        }
      }
    } catch (e) {
      console.warn('Route guard error:', e);
    }
  }

  window.addEventListener('load', run);
})();
